import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import {
  FormBuilder,
  FormGroup,
} from "@angular/forms";
import { Questao } from "../models/questao.model";
import { QuestaoService } from "../services/questao.service";
@Component({
  selector: "app-pesquisa",
  templateUrl: "./pesquisa.component.html",
})
export class PesquisaComponent implements OnInit {
  questoes: Questao[] = [];
  paginas: string[] = [];
  pagina: number = 1;
  config: any;
  textoPesquisa: string = null;
  categorizadas: boolean = false;
  disabled: boolean = true;

  //#region paginacao
  public labels: any = {
    previousLabel: "Anterior",
    nextLabel: "Próxima",
    screenReaderPaginationLabel: "Paginação",
    screenReaderPageLabel: "pagina",
    screenReaderCurrentLabel: `Você está na pagina`,
  };
  //#endregion

  constructor(
    private questaoService: QuestaoService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder
  ) {
    this.pagina = 1;
    this.config = {
      currentPage: 1,
      itemsPerPage: 1,
      totalItems: 0,
    };
    this.route.queryParams.subscribe(
      (params) =>
        (this.config.currentPage = params["page"] ? params["page"] : 1)
    );
  }
  ngOnInit(): void {
    this.pagina = 1;
  }
  pesquisar() {
    this.router.navigate(["/questao/pesquisa"], { queryParams: { pagina: 1 } });
    this.listar(this.textoPesquisa, this.categorizadas, 1);
  }
  listar(textoPesquisa: string, categorizada: boolean, pagina: number) {
    this.questaoService
      .buscar(textoPesquisa, categorizada, pagina)
      .subscribe((r) => {
        if (r.success) {
          this.questoes = r.data.items;
          for (let index = 1; index < r.data.totalPages; index++) {
            this.paginas.push(index.toString());
          }
          this.config = {
            currentPage: r.data.pageNumber,
            itemsPerPage: r.data.pageSize,
            totalItems: r.data.totalRecords,
          };
          this.route.queryParams.subscribe(
            (params) =>
              (this.config.currentPage = params["pagina"]
                ? params["pagina"]
                : 1)
          );
        } else {
        }
      });
  }
  pageChange(newPage: number) {
    this.router.navigate(["/questao/pesquisa"], {
      queryParams: { pagina: newPage },
    });
    this.listar(this.textoPesquisa, this.categorizadas, newPage);
  }
}